import { FC, useEffect, useRef } from 'react';
import { Text, CheckCircle } from '@doda/io-react/common';
import { TAB_JOBDETAIL } from '@doda/common/src/constants/properties/const';
import { useIntersection } from '@doda/common/src/hooks/useIntersection';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { tabSelector } from '@doda/pc/src/redux/selectors/queryParams';
import { CheckMarkBalloon } from '../CheckMarkBalloon';
import styles from './index.module.scss';
import { Tab } from '../../types/tab';

/**
 * ArticleSummaryのProps
 */
export interface Props {
  articleSummaryList: string[];
  initialTab: Tab;
  /** 要約エリアが画面に入ったときに呼ぶ関数（imp計測用） */
  onVisible?: () => void;
}

/**
 * 記事要約コンポーネント
 */
export const ArticleSummary: FC<Props> = ({
  articleSummaryList,
  initialTab,
  onVisible,
}) => {
  const tab = useAppSelector(tabSelector) ?? initialTab;
  const ref = useRef<HTMLDivElement>(null);
  // imp計測の対象（onVisibleあり）のときだけ監視する
  // タブの切り替えでエリアが出直すため、タブが変わるたびに監視し直す
  const { intersecting } = useIntersection(ref, undefined, [
    tab,
    Boolean(onVisible),
  ]);

  useEffect(() => {
    if (intersecting) onVisible?.();
  }, [intersecting, onVisible]);

  if (tab !== TAB_JOBDETAIL) return null;
  return (
    <div
      ref={onVisible ? ref : undefined}
      className={styles['jobSearchDetail-articleSummary__wrapper']}
    >
      <div
        className={styles['jobSearchDetail-articleSummary__checkMarkPosition']}
      >
        <CheckMarkBalloon />
      </div>
      <div className={styles['jobSearchDetail-articleSummary_title']}>
        <Text color="white" size="14--articlePC" weight="bold">
          この求人を要約すると
          <span
            className={styles['jobSearchDetail-articleSummary__textEllipsis']}
          >
            …
          </span>
        </Text>
      </div>
      <div className={styles['jobSearchDetail-articleSummary__contents']}>
        {articleSummaryList.map((articleSummary, i) => (
          <div
            key={i}
            className={styles['jobSearchDetail-articleSummary__item']}
          >
            <CheckCircle size="M" color="blue" />
            <Text color="black_pc" size="14--articlePC" weight="bold">
              {articleSummary}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
};
